module.exports = __webpack_public_path__ + "static/media/mansi_kumar.b6ec04c0.png";